import React from "react";
import "./Footer.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import {
  faFacebook,
  faInstagram,
  faTwitter,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import hotelLogo1 from "./image/hotellogo.png";

const Footer = () => {
  return (
    <footer className=" text-light pt-4 pb-2">
      <div className="container">
        <div className="row">
          {/* Logo Section */}
          <div className="col-md-3 mb-3 text-center text-md-start">
            <img
              src={hotelLogo1} // Add your logo URL here
              alt="Logo"
              className="footer-logo"
            />
          </div>

          {/* About Us Section */}
          <div className="col-md-3 mb-3">
            <Link className="nav-link text-warning" to="/about"><h5>About Us</h5></Link>
            <p>
              Hotel Management is the art and science of providing exceptional
              hospitality services and managing accommodations with efficiency.
            </p>
          </div>

          {/* Services Section */}
          <div className="col-md-3 mb-3">
          <Link className="nav-link text-warning" to="/services"><h5>Our Services</h5></Link>
            <ul className="list-unstyled">
              <li>Luxury Accommodation</li>
              <li>Event Management</li>
              <li>Fine Dining</li>
              <li>Travel Assistance</li>
            </ul>
          </div>

          {/* Contact Info Section */}
          <div className="col-md-3 mb-3">
            <Link className="nav-link text-warning" to="/about"><h5>Contact Info</h5></Link>
            <ul className="list-unstyled">
              <li>
                <a href="tel:+918081143880" className="text-light">
                  <FontAwesomeIcon icon={faPhone} /> +91 8081143880
                </a>
              </li>
              <li>
                <a
                  href="mailto:hotelmanagement@gmail.com"
                  className="text-light"
                >
                  <FontAwesomeIcon icon={faEnvelope} /> hotelmanagement@gmail.com
                </a>
              </li>
              <li>📍 123 Luxury Street, City, Country</li>
            </ul>
          </div>
        </div>

        {/* Newsletter and Social Media */}
        <div className="row mt-3">
          <div className="col-md-6 text-center text-md-start mb-3">
            <h5 className="text-warning">Subscribe to Our Newsletter</h5>
            <div className="input-group" style={{marginLeft:'-5px'}}>
              <input
                type="email"
                className="form-control"
                placeholder="Enter your email"
              />
              <button className="btn btn-warning" type="button">
                Subscribe
              </button>
            </div>
          </div>
          <div className="col-md-4 text-center text-md-start">
            <h5 className="text-warning">Follow Us</h5>
            <div className="social-icons">
              <a href="https://facebook.com" className="text-light mx-2">
                <FontAwesomeIcon icon={faFacebook} size="2x" />
              </a>
              <a href="https://instagram.com" className="text-light mx-2">
                <FontAwesomeIcon icon={faInstagram} size="2x" />
              </a>
              <a href="https://twitter.com" className="text-light mx-2">
                <FontAwesomeIcon icon={faTwitter} size="2x" />
              </a>
              <a href="https://linkedin.com" className="text-light mx-2">
                <FontAwesomeIcon icon={faLinkedin} size="2x" />
              </a>
            </div>
          </div>
            <div className="col-md-2 text-center text-md-end">
            <a href="/home" className="btn btn-warning">
              Go to Home
            </a>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="row mt-4">
          <div className="col-md-12 text-center ">
            <p className="mb-0">
              © 2024 Your Hotel Management. All Rights Reserved | Design by{" "}
              <span className="text-warning">KSS Student</span>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
